import { useCallback } from "react";
import { AppConstants } from "../../../constants/constant";
import {
  FormValues,
  Franchise,
  FranchiseDetail,
} from "../../../Interface/scheduler/form";
import { formatPhoneNumber } from "../../../common/components/Helper/Helper";

const useFilterData = (formValues: FormValues) => {
  const filterData = useCallback(
    (data: Franchise[]) => {
      let details = data?.flatMap((f: Franchise) =>
        f?.franchiseDetails?.map((detail) => ({
          ...detail,
          franchiseId: f.franchiseId,
          distance: detail?.distanceFromPostalCode
            ? detail?.distanceFromPostalCode
            : detail?.distance,
          phoneNumber: formatPhoneNumber(detail?.phoneNumber),
        }))
      );
      if (formValues.countryCode === "us") {
        details = details?.filter(
          (c: FranchiseDetail) =>
            c.country === AppConstants.COUNTRY_US_CODE ||
            c.country === AppConstants.COUNTRY_US_NAME
        );
      } else {
        details = details?.filter(
          (c: FranchiseDetail) =>
            c.country === AppConstants.COUNTRY_CA_CODE ||
            AppConstants.COUNTRY_CA_NAME
        );
      }
      const result = [];
      const set = new Set();
      for (const detail of details || []) {
        if (!set.has(detail?.franchiseWebLocationId)) {
          result.push(detail);
          set.add(detail?.franchiseWebLocationId);
        }
      }
      return result;
    },
    [formValues]
  );

  return { filterData };
};

export default useFilterData;
